import Joi from '@hapi/joi'

export const userSchemaObject = {
    userName: Joi.string().required().label("User Name").messages({ "string.empty": `User Name Required`, }),
    passwordHash: Joi.string().required().label("Password").regex(/^(?=.{5,})/).messages({
        "string.pattern.base": `"Invalid Password"`,
        "string.empty": `Password Required`,
    }),
    email: Joi.string().label("Email").allow("", null).regex(/^(?!\s*$).+/),

    roleId: Joi.string().invalid("0").required().label("Role").messages({ "string.empty": `Role Required`, }),
    groupID: Joi.number().invalid(0).required().label("Group").messages({ "any.invalid": `Group Required`, }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({ "any.invalid": `Operation Entity Required`, }),
    firstName: Joi.string().required().label("First Name").messages({ "string.empty": `First Name Required`, }),
    lastName: Joi.string().required().label("Last Name").messages({ "string.empty": `Last Name Required`, }),
    isActive: Joi.boolean().label("Active"),
    isLocked: Joi.boolean().label("IsLocked"),

    userName: Joi.string().required().label("User Name").regex(/^[\S]+$/).messages({
        "string.empty": `User Name Required`,
        "string.pattern.base": `User Name not allowing to enter spaces`,
    }),
}

export const UserFilterSchema = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Please Select the Valid Group`,
        "any.required": `Group required`
    }),

    operationEntityID: Joi.number().invalid(0).required().label("operation Entity ID").messages({
        "any.invalid": `Please Select the Valid Estate`,
        "any.required": `Estate required`
    }),

}
